import { StandardError } from '../base-error';
import { ErrorCodes } from '../error-codes';

export class UnauthorizedError extends StandardError {
  constructor(message: string, properties: any = {}) {
    super(message, ErrorCodes.UNAUTHORIZED, { errorName: 'Unauthorized Error', ...properties });
  }
}
